import { useServiceError } from '@/hooks';
import { useMutation } from 'react-query';
import {
  generateQuotationMap,
  generateWorkOrderSoldHours,
} from './WorkOrder.service';
import {
  ReportWorkOrderQuotationMapRequest,
  ReportWorkOrderSoldHoursRequest,
} from './WorkOrder.types';
import { notification } from 'antd';

export function useWorkOrderSoldHours() {
  const mutation = useMutation((obj: ReportWorkOrderSoldHoursRequest) =>
    generateWorkOrderSoldHours(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useWorkOrderQuotationMap() {
  const mutation = useMutation(
    (obj: ReportWorkOrderQuotationMapRequest) => generateQuotationMap(obj),
    {
      onSuccess() {
        notification.success({
          message: 'Relatório gerado com sucesso!',
          description: 'Relatório mara de cotação gerado com sucesso.',
        });
      },
    },
  );

  useServiceError(mutation.error);

  return mutation;
}
